module.exports = __webpack_public_path__ + "assets/img/18_1672.933a5278.jpg";